import { defineStore } from 'pinia'

export const usePostDetails = defineStore('post-details', {
    state() {
        return {
            currentPost: null,
            successTrigger: 0
        }
    },

    actions: {
        updateConnection(postId, connectionId, changes) {
            if(this.currentPost.id === postId) {
                const index = this.currentPost.connections.findIndex(connection => connection.id === connectionId);
                Object.assign(this.currentPost.connections[index], changes);

                // Post success
                if(changes.status !== undefined && changes.status === 'published') {
                    this.$patch({successTrigger: this.successTrigger + 1});
                }
            }
        }
    }
});
